import React, { useMemo } from 'react'
import { Table } from 'react-bootstrap'

import { formatMoney } from '../../helpers/utils'
import { getRefundNcrDisplayValue, getRefundStatusOption } from '../helpers/refundDisplay'
import { getFormattedRefundDate, showRefundModel } from '../helpers/refundIndexFilters'

const isEmptyNcr = (model) => getRefundNcrDisplayValue(model) === '-'

const sortEmptyNcrFirst = (rows = []) =>
  [...rows].sort((left, right) => {
    const leftEmpty = isEmptyNcr(left)
    const rightEmpty = isEmptyNcr(right)
    if (leftEmpty === rightEmpty) return 0
    return leftEmpty ? -1 : 1
  })

export default function RefundIndexDesktopTable({ data, showNcrColumn }) {
  const rows = useMemo(() => {
    if (!data?.length) return []
    return showNcrColumn ? sortEmptyNcrFirst(data) : data
  }, [data, showNcrColumn])

  return (
    <Table hover responsive style={{ marginBottom: 0 }}>
      <thead className="table-header-gray-mui">
        <tr>
          <th className="vertical-align-middle" style={{ padding: '10px 25px' }}>
            FECHA DE DOCUMENTO
          </th>
          <th className="vertical-align-middle"># DE DEVOLUCIÓN</th>
          {showNcrColumn ? <th className="vertical-align-middle">NCR</th> : null}
          <th className="vertical-align-middle">CÓDIGO DE CLIENTE</th>
          <th className="vertical-align-middle">NOMBRE DE CLIENTE</th>
          <th className="vertical-align-middle">CREADO POR</th>
          <th className="vertical-align-middle">BODEGA</th>
          <th className="vertical-align-middle">TOTAL DEVOLUCIÓN</th>
          <th className="vertical-align-middle th-end-pos">ESTADO</th>
        </tr>
      </thead>
      <tbody>
        {rows.length > 0 ? (
          rows.map((model) => (
            <tr className="cursor-pointer" key={model.uuid}>
              <td
                className="td-text-limited td-text-limited-space"
                onClick={(event) => showRefundModel(event, model.uuid)}
              >
                {getFormattedRefundDate(model.created_date)}
              </td>
              <td
                className="td-text-limited"
                onClick={(event) => showRefundModel(event, model.uuid)}
              >
                {model.db_ref}
              </td>
              {showNcrColumn ? (
                <td
                  className="td-text-limited"
                  onClick={(event) => showRefundModel(event, model.uuid)}
                >
                  {getRefundNcrDisplayValue(model)}
                </td>
              ) : null}
              <td
                className="td-text-limited"
                onClick={(event) => showRefundModel(event, model.uuid)}
              >
                {model.client_db_ref}
              </td>
              <td
                className="td-text-limited"
                onClick={(event) => showRefundModel(event, model.uuid)}
              >
                {model.client_description}
              </td>
              <td
                className="td-text-limited"
                onClick={(event) => showRefundModel(event, model.uuid)}
              >
                {model.salesman_db_ref} - {model.salesman_name}
              </td>
              <td
                className="td-text-limited"
                onClick={(event) => showRefundModel(event, model.uuid)}
              >
                {model.warehouse_name || '-'}
              </td>
              <td
                className="td-text-limited"
                onClick={(event) => showRefundModel(event, model.uuid)}
              >
                {formatMoney(Number(model.total))}
              </td>
              <td onClick={(event) => showRefundModel(event, model.uuid)}>
                <div className="td-order-status">
                  {(() => {
                    const statusOption = getRefundStatusOption(model)
                    return statusOption ? (
                      <div className={statusOption.className}>{statusOption.label}</div>
                    ) : (
                      <div className="order-status">
                        {String(model.status || '-').toUpperCase()}
                      </div>
                    )
                  })()}
                </div>
              </td>
            </tr>
          ))
        ) : (
          <tr>
            <td
              colSpan={showNcrColumn ? 9 : 8}
              className="td-text-limited td-text-limited-space"
            >
              No hay devoluciones disponibles.
            </td>
          </tr>
        )}
      </tbody>
    </Table>
  )
}
